import { isCustomView } from './isCustomView';
/**
 * @deprecated use same function from '@alilc/lowcode-utils' instead
 */

export function isSetterConfig(obj) {
  return obj && typeof obj === 'object' && 'componentName' in obj && !isCustomView(obj);
}